import React, { Fragment, useEffect, useState, useCallback } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { useHistory, useLocation, useParams, useRouteMatch } from 'react-router';
import { useDispatch, useMappedState, StoreContext } from 'redux-react-hook';
/** mod start*/
import { CopyrightHome } from './home';
import { CopyrightLogin } from './login';
import { CopyrightWXLogin } from './wxLogin';
import { CopyrightMiniLogin } from './miniLogin';
import { CopyrightUpload } from './upload';
import { CopyrightActivity } from './activity';
import { CopyrightEvents } from './events';
import { CopyrightGallery } from './gallery';
import { CopyrightUcenter } from './ucenter';
import { CopyrightIdetail } from './idetail';
import { CopyrightAbout } from './about';
import { CopyrightSetting } from './setting';
import { CopyrightEditor } from './editor';
import { CopyrightNotice } from './notice';
import { CopyrightActivityList } from './activityList';
import { CopyrightVideo } from './video';
import { CopyrightUppy } from './uppy';
import { CopyrightSharedPage } from './sharedPage';
import { CopyrightPraise } from './praise';
import { CopyrightSearch } from './search';
import { CopyrightTopic } from './topic';
import { CopyrightNews } from './news';
import { CopyrightNewsDetail } from './newsDetail';
import { loadWeixinScript, getWeixinToken, weixinAuth, shouldWeixinAuth } from '../../utils/weixin';
import { isWeixin, isWeixinWork, readCookie, createCookie, launchFullScreen } from '../../utils/common';
import { getCopyrightUserInfo } from '../commonAction';
import { AuthPrompt } from '../../components/copyright/authPrompt';
import { _track } from '../../utils/track';
import { isMiniApp } from '../../utils/miniApp';
/**mod end */
import 'amfe-flexible';
let globalFlag = 0;
(async () => {
	globalFlag = await isMiniApp();
})();
loadWeixinScript();
const mapStateToProps = async state => {
	// let bool = await isMiniApp();
	// console.log ( "look" , bool);
	return {
		baseInfo: state.CopyrightBaseinfoReducers.baseinfo
	};
};
// let getWxEnv = async ()=>{
// 	let flag = await isMiniApp();
// 	return flag;
// }
function App() {
	let dispatch = useDispatch();
	const mapState = useCallback(mapStateToProps, []);
	const { baseInfo } = useMappedState(mapState);
	let [isShowAuthPrompt, setShowAuthPrompt] = useState(false);
	// console.log('baseInfo', baseInfo);
	// let params = useParams();
	// let routeMatch = useRouteMatch();
	let headers = new Headers();
	// *** I set the header in order to solve the error above:
	// *** The value is set to "/" because this js is included in html file in upper folder.
	// *** I tried even "../" and many more others values...
	headers.append('Service-Worker-Allowed', '/vpmobile');
	// let hrefString = window.location.href;
	// // let pathname = location.pathname;
	// let [showTip, setShowTip] = useState(true);
	// function hideAuthTip() {
	// 	(false);
	// }
	// useEffect(() => {
	// 	let token = readCookie('copyrighttoken');
	// 	let userId = readCookie('copyrightuserId');
	// 	if (token && userId) {
	// 		hideAuthTip();
	// 	} else if (hrefString.indexOf('/vpmobile/copyright/login') >= 0) {
	// 		hideAuthTip();
	// 	}
	// });
	useEffect(() => {
		if (shouldWeixinAuth()) {
			(async () => {
				let flag = globalFlag; //await isMiniApp();
				// alert("flag")
				if (flag === 1) {
					let bHasCode = weixinAuth({
						scopeType: 'snsapi_userinfo'
					});
					console.log('bHasCode', bHasCode);
				}
			})();
		} else {
			// alert(globalFlag)
			// (async () =>{
			// 	let flag = await isMiniApp();
			// 	alert(flag);
			// })();
			// alert(readCookie("userToken"))
		}
		// let domHtml = document.getElementsByName('html');
		// document.getElementsByTagName('html')[0].style.cssText = 'font-size: 45.3px;';
		let userId = readCookie('copyrightuserId');
		// let copyright_nickname = readCookie('copyright_nickname');
		// let copyright_avatar = readCookie('copyright_avatar');
		// let copyright_iscontract = readCookie('copyright_iscontract');
		// let copyright_instName = readCookie('copyright_instName');
		// let copyright_showState = readCookie('copyright_showState');
		if (userId) {
			dispatch(
				getCopyrightUserInfo({ userId }, data => {
					let { nickname = '', avatar = '', contractState, instName = '', showState, firstUpdate } = data;
					createCookie('copyright_nickname', nickname || '', 180);
					createCookie('copyright_avatar', avatar || '', 180);
					createCookie('copyright_iscontract', contractState === 2, 180);
					// createCookie('copyright_isphotographer', contractState === 2, 180);
					createCookie('copyright_instName', instName || '', 180);
					createCookie('copyright_showState', showState, 180);
					createCookie('copyright_firstUpdate', firstUpdate, 180);
				})
			);
		}
	}, [dispatch]);
	// let location = useLocation();
	let pathname = document.location.pathname;
	useEffect(() => {
		// console.log('changed:', pathname);
		// window['sensors'] && sensors.quick('autoTrackSinglePage');
	}, [pathname]);
	useEffect(() => {
		// console.log ("error");
		launchFullScreen();
	});
	return (
		<React.Profiler id="application" onRender={() => {}}>
			<Router>
				<Fragment>
					<Route exact path="/vpmobile/copyright/home" component={CopyrightHome} />
					<Route exact path="/vpmobile/copyright/login" component={CopyrightLogin} />
					<Route exact path="/vpmobile/copyright/wxLogin" component={CopyrightWXLogin} />
					<Route exact path="/vpmobile/copyright/miniLogin" component={CopyrightMiniLogin} />
					<Route exact path="/vpmobile/copyright/upload/:id([a-zA-Z0-9\.\-]+)?/:uploadType(\d+)?" component={CopyrightUpload} />
					<Route exact path="/vpmobile/copyright/activitylist" component={CopyrightActivityList} />
					<Route exact path="/vpmobile/copyright/events" component={CopyrightEvents} />
					<Route exact path="/vpmobile/copyright/activity/:id([a-zA-Z0-9\.\-]+)?/:comeFrom?" component={CopyrightActivity} />
					<Route exact path="/vpmobile/copyright/gallery" component={CopyrightGallery} />
					<Route exact path="/vpmobile/copyright/ucenter" component={CopyrightUcenter} />
					<Route exact path="/vpmobile/copyright/idetail" component={CopyrightIdetail} />
					<Route exact path="/vpmobile/copyright/about" component={CopyrightAbout} />
					<Route exact path="/vpmobile/copyright/setting" component={CopyrightSetting} />
					<Route exact path="/vpmobile/copyright/editor" component={CopyrightEditor} />
					<Route exact path="/vpmobile/copyright/notice" component={CopyrightNotice} />
					<Route exact path="/vpmobile/copyright/sharedPage" component={CopyrightSharedPage} />
					<Route exact path="/vpmobile/copyright/praise" component={CopyrightPraise} />
					<Route exact path="/vpmobile/copyright/topic" component={CopyrightTopic} />
					<Route exact path="/vpmobile/copyright/news" component={CopyrightNews} />
					<Route exact path="/vpmobile/copyright/newsDetail/:id([a-zA-Z0-9\.\-]+)?" component={CopyrightNewsDetail} />
					<Route exact path="/vpmobile/copyright/search/:ref(\d+)?/:searchType(\d+)?" component={CopyrightSearch} />
					{/* <Route exact path="/operation" component={Operation} />
					<Route exact path="/adwall/financial/list" component={FinancialList} />
					<Route exact path="/adwall/financial/edit/:id(\d+)?" component={FinancialEditForm} /> */}
					{/* :id(\d)?  \d代表数字 ? 代表该参数可有可无 +代表一个或者多个*/}
					{/* <Route exact path="/ad/list/:listType(plan|product-group)" component={AdList} />
					<Route exact path="/ad/edit/:id(\d+)?" component={AdEditForm} />
					<Route exact path="/:path([a-zA-Z0-9\.\-]+)?" component={Home} /> */}
					{/* <AuthTip onclick={() => {}} /> */}
					<Route exact path="/vpmobile/copyright/video" component={CopyrightVideo} />
					<Route exact path="/vpmobile/copyright/uppy" component={CopyrightUppy} />
				</Fragment>
			</Router>
			{isShowAuthPrompt ? <AuthPrompt /> : ''}
		</React.Profiler>
	);
}
export default App;
